var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{staticClass:"cls-1",attrs:{"d":"M2.33,44.58,117.33.37a3.63,3.63,0,0,1,5,4.56l-44,115.61h0a3.63,3.63,0,0,1-6.67.28L53.93,84.14,89.12,33.77,38.85,68.86,2.06,51.24a3.63,3.63,0,0,1,.27-6.66Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }